import React from "react";
import './ProgressBar.scss';

export default class ProgressBar extends React.PureComponent<{ title: string, value: number, cardCount: number}, {}> {

    render(): React.ReactNode {
        let { title, value, cardCount} = this.props;
        let progressBarStyle = {
            position: "absolute",
            width: "3px",
            background: "red",
            height: "1vh",
            right: "50%"
        };
        return <>
            <div className="progress-bar-area">
                <label>
                    {title}
                </label>
                <div className="progress">
                    <div className="progress-bar" role="progressbar" aria-valuenow={value}
                        aria-valuemin={0} aria-valuemax={100} style={{ width: value + "%" }}>
                    </div>
                    <div></div>
                </div>
                <label>
                    {cardCount}
                </label>
            </div>
        </>
    }
}